import { createContext, type FC, type PropsWithChildren, useContext } from 'react'

import { useDeviceCatalogCart } from 'modules/it_management/hooks/device_catalog/useDeviceCatalogCart'

type CartContextValue = ReturnType<typeof useDeviceCatalogCart>

const DeviceCatalogCartContext = createContext<CartContextValue | null>(null)

export const DeviceCatalogCartProvider: FC<PropsWithChildren> = ({ children }) => {
  const cart = useDeviceCatalogCart()
  return (
    <DeviceCatalogCartContext.Provider value={cart}>
      {children}
    </DeviceCatalogCartContext.Provider>
  )
}

export function useDeviceCatalogCartContext(): CartContextValue {
  const context = useContext(DeviceCatalogCartContext)
  if (!context) {
    throw new Error(
      'useDeviceCatalogCartContext must be used within DeviceCatalogCartProvider'
    )
  }
  return context
}
